import { render, staticRenderFns } from "./AuditTrailTable.vue?vue&type=template&id=e5728346&scoped=true"
import script from "./AuditTrailTable.vue?vue&type=script&lang=ts"
export * from "./AuditTrailTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5728346",
  null
  
)

export default component.exports